// File-control
$(document).ready(function() {

	// fill placeholder on click file-select
	$('.file-control .file-select, .file-control .file-placeholder').on('click', function(e) {
		e.preventDefault();

		var fileWidth = $(this).parent().width() - 20;
		$(this).parent().find('input[type="file"]').trigger('click');
	});

	// fill placeholder on click group-append
	$('.file-control .group-append').on('click', function(e) {
		e.preventDefault();

		var fileWidth = $(this).parent().find('.file-select').width();
		$(this).parent().find('input[type="file"]').trigger('click');
	});

	// check change
	$(document).on('change', '.file-control input[type="file"]', function() {
		if(this.files.length>1) {
			var filename = this.files.length+' bestanden geselecteerd';
		} else {
			var filename = ''+$(this)[0].files[0].name+' <span class="text-sm">('+humanFileSize($(this)[0].files[0].size)+')</span>';
		}
		$(this).parent().find('.file-select').addClass('hide');
		$(this).parent().find('.file-placeholder').html(filename);
		$(this).parent().find('.file-placeholder').width(fileWidth);
	});

	function humanFileSize(bytes) {
		var i = -1;
		var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
		do {
			bytes = bytes / 1024;
			i++;
		} while (bytes > 1024);

		return Math.max(bytes, 0.1).toFixed(1) + byteUnits[i];
	}

	$(document).ready(resizeFileInputs);
	$(window).resize(resizeFileInputs);
	function resizeFileInputs() {
		if ($('.file-select').is(':visible')) {
			$('.file-select').each(function() {
				$(this).css('width', 50);
				var fileSelectWidth = $(this).parent().width() - 20;
				if(fileSelectWidth>0) {
					$(this).width(fileSelectWidth);
				} else {
					$(this).css('width', 'auto');
				}
			});
			$('.file-placeholder').each(function() {
				$(this).css('width', 50);
				var filePlaceholderWidth = $(this).parent().width() - 20;
				if(filePlaceholderWidth>0) {
					$(this).width(filePlaceholderWidth);
				} else {
					$(this).css('width', 'auto');
				}
			});
		}
	}

});
